import { render, staticRenderFns } from "./plan-template-mod.vue?vue&type=template&id=efb3f0d4"
import script from "./plan-template-mod.vue?vue&type=script&lang=js"
export * from "./plan-template-mod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports